import { render, staticRenderFns } from "./CreateReportButton.vue?vue&type=template&id=7284a04a&"
import script from "./CreateReportButton.vue?vue&type=script&lang=ts&"
export * from "./CreateReportButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports